import { AuthService } from '../../providers'

const AuthModule = {
  namespaced: true,
  state: {
    loginResult: {},
    chooseLineAccountResult: {}
  },
  mutations: {
    SET_LOGIN_RESULT (state, data) {
      state.loginResult = data
    },
    SET_CHOOSE_LINE_ACCOUNT_RESULT (state, data) {
      state.chooseLineAccountResult = data
    }
  },
  actions: {
    async login ({ commit }, params) {
      const result = await AuthService.login(params)
      commit('SET_LOGIN_RESULT', result)
      return result
    },
    async chooseLineAccount({ commit }, params) {
      const result = await AuthService.chooseLineAccount(params)
      commit('SET_CHOOSE_LINE_ACCOUNT_RESULT', result)
      return result
    }
  },
  getters: {
    isLogin (state) {
      return Object.keys(state.loginResult).length > 0
    }
  }
}

export default AuthModule
